// extracted by mini-css-extract-plugin
module.exports = {"list":"MassMailingList_list__1Qh8m"};